interface CastButtonProps {
  className?: string;
}

export function CastButton({ className }: CastButtonProps) {
  // Since the google-cast-launcher is a web component, we dont use the
  // className prop to add the class to the element. Instead we use the
  // class attribute.
  return <google-cast-launcher class={className} />;
}
